
import { Component, Prop, Mixins } from 'vue-property-decorator';
import AvisoAlCerrar from '@/mixins/AvisoAlCerrar';
import AvisoSinGuardar from '@/components/core/AvisoSinGuardar.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ApiHelper from '@/helpers/api-helper';
import CargandoFicha from '@/components/core/CargandoFicha.vue';
import BudgetService from '@/services/BudgetService';
import AccomodationService from '@/services/AccomodationService';
import FormatHelper from '@/helpers/format-helper';

@Component({
	components: {
		AvisoSinGuardar,
		CargandoFicha,
		ValidationProvider,
		ValidationObserver,
	},
})
export default class CustomerBudgetPdfForm extends Mixins(AvisoAlCerrar) {
	@Prop({ default: null, required: true }) private edit_id;

	$refs!: {
		obs: InstanceType<typeof ValidationObserver>;
	};

	private loading = false;
	private cargaFallida = false;
	private formTitle = '';
	private budget = {};

	/** N-291 (T5b): lo que GUARDAR mandaría (las tablas de precios comparten el array con el modelo). */
	loQueSeGuardaria() {
		return JSON.stringify(this.budget);
	}

	mounted() {
		if (this.edit_id) {
			this.loading = true;
			this.formTitle = 'Edit budget PDF';
			BudgetService.getPdfDetails(this.edit_id)
				.then(res => {
					if (res.status === 200) {
						this.budget = res.data;
						this.loading = false;
						this.fotoSinCambios();
					}
				})
				.catch(error => {
					this.cargaFallida = true;
					ApiHelper.handleErrors(error, {}, this.$bus);
				});
		} else {
			this.formTitle = 'New budget';
			this.fotoSinCambios();
		}
	}

	async update() {
		const component = this;
		const validForm = await this.$refs['obs'].validate();
		if (validForm) {
			BudgetService.updatePDF(this.budget)
				.then(res => {
					if (res.status === 200) {
						this.$emit('saved');
					}
				})
				.catch(error => {
					ApiHelper.handleErrors(error, component.$refs['obs'], this.$bus);
				});
		}
	}

	getAcommodationType(feature_id) {
		if (feature_id == AccomodationService.BOARD_BASIC_TYPE_ID) {
			return 'Desayuno incluido';
		} else if (feature_id == AccomodationService.BOARD_HALF_TYPE_ID) {
			return  'Media pensión (Desayuno y cena)';
		} else if (feature_id == AccomodationService.BOARD_FULL_TYPE_ID) {
			return 'Pensión completa (Desayuno, almuerzo y cena)'
		}
	}

	priceFormat(price) {
		return FormatHelper.formatPrice(price);
	}
}
